module.exports = __webpack_public_path__ + "img/english-kids-en.5d18fb80.png";